/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { SimulationStatus } from './SimulationStatus';
import {
    SimulationStatusFromJSON,
    SimulationStatusFromJSONTyped,
    SimulationStatusToJSON,
    SimulationStatusToJSONTyped,
} from './SimulationStatus';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';
import type { PriceUnitDto } from './PriceUnitDto';
import {
    PriceUnitDtoFromJSON,
    PriceUnitDtoFromJSONTyped,
    PriceUnitDtoToJSON,
    PriceUnitDtoToJSONTyped,
} from './PriceUnitDto';

/**
 * 
 * @export
 * @interface GetSimulationResponse
 */
export interface GetSimulationResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSimulationResponse
     */
    id: number;
    /**
     * Human readable simulation name.
     * @type {string}
     * @memberof GetSimulationResponse
     */
    simulationName: string;
    /**
     * 
     * @type {SimulationStatus}
     * @memberof GetSimulationResponse
     */
    status: SimulationStatus;
    /**
     * 
     * @type {number}
     * @memberof GetSimulationResponse
     */
    planningYear: number;
    /**
     * 
     * @type {Date}
     * @memberof GetSimulationResponse
     */
    planningValidFrom: Date;
    /**
     * 
     * @type {UserDto}
     * @memberof GetSimulationResponse
     */
    assignedTo: UserDto;
    /**
     * Indicates whether publishing of prices is blocked for this simulation, e.g. because it was created with a planning date in the past.
     * @type {boolean}
     * @memberof GetSimulationResponse
     */
    isPublishingOfPricesBlocked: boolean;
    /**
     * 
     * @type {Array<PriceUnitDto>}
     * @memberof GetSimulationResponse
     */
    planningPriceUnits: Array<PriceUnitDto> | null;
}



/**
 * Check if a given object implements the GetSimulationResponse interface.
 */
export function instanceOfGetSimulationResponse(value: object): value is GetSimulationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('simulationName' in value) || value['simulationName'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('planningYear' in value) || value['planningYear'] === undefined) return false;
    if (!('planningValidFrom' in value) || value['planningValidFrom'] === undefined) return false;
    if (!('assignedTo' in value) || value['assignedTo'] === undefined) return false;
    if (!('isPublishingOfPricesBlocked' in value) || value['isPublishingOfPricesBlocked'] === undefined) return false;
    if (!('planningPriceUnits' in value) || value['planningPriceUnits'] === undefined) return false;
    return true;
}

export function GetSimulationResponseFromJSON(json: any): GetSimulationResponse {
    return GetSimulationResponseFromJSONTyped(json, false);
}

export function GetSimulationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSimulationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'simulationName': json['simulationName'],
        'status': SimulationStatusFromJSON(json['status']),
        'planningYear': json['planningYear'],
        'planningValidFrom': (new Date(json['planningValidFrom'])),
        'assignedTo': UserDtoFromJSON(json['assignedTo']),
        'isPublishingOfPricesBlocked': json['isPublishingOfPricesBlocked'],
        'planningPriceUnits': (json['planningPriceUnits'] == null ? null : (json['planningPriceUnits'] as Array<any>).map(PriceUnitDtoFromJSON)),
    };
}

export function GetSimulationResponseToJSON(json: any): GetSimulationResponse {
    return GetSimulationResponseToJSONTyped(json, false);
}

export function GetSimulationResponseToJSONTyped(value?: GetSimulationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'simulationName': value['simulationName'],
        'status': SimulationStatusToJSON(value['status']),
        'planningYear': value['planningYear'],
        'planningValidFrom': (formatDateOnly(value['planningValidFrom'])),
        'assignedTo': UserDtoToJSON(value['assignedTo']),
        'isPublishingOfPricesBlocked': value['isPublishingOfPricesBlocked'],
        'planningPriceUnits': (value['planningPriceUnits'] == null ? null : (value['planningPriceUnits'] as Array<any>).map(PriceUnitDtoToJSON)),
    };
}

